module.exports = __webpack_public_path__ + "static/img/zongxin.e6701a6b.png";